import * as React from 'react';
import { Button, SageTokens } from '@kajabi/sage-react';
import useDeleteResultItem from 'common/components/CopyMagic/hooks/useDeleteResultItem';

type Props = {
  attributePath: (string | number)[];
  className?: string;
};

const DeleteResultItemButton = ({ attributePath, className = '' }: Props) => {
  const handleDelete = useDeleteResultItem({ attributePath });

  if (!attributePath.length) {
    return null;
  }

  return (
    <Button
      subtle
      iconOnly
      className={className}
      color={Button.COLORS.PRIMARY}
      icon={SageTokens.ICONS.TRASH}
      onClick={handleDelete}
    >
      Delete
    </Button>
  );
};

export default DeleteResultItemButton;
